module.exports = __webpack_public_path__ + "static/media/sqlite.32328270.svg";